<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between" class="mb-4">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">
          {{ "Scratch Card Details".toUpperCase() }}
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="dataValid">
      <v-alert type="info" class="mt-4">
        Scratch card purchase {{hasScratchCards ? 'made' : 'required'}}. Reload this page few seconds after payments
      </v-alert>
      <v-alert type="warning" prominent>
        If you have already paid for this scratch card, do not click Purchase again. Reload this page after a few seconds to confirm your payment.
      </v-alert>
      <v-alert v-if="hasMixedOrganizations" type="info" prominent class="mixed-result-advice">
        You selected NECO with another examination result. Purchase the NECO scratch card first. After the payment is confirmed, you can enter the other scratch card details manually.
      </v-alert>
      <v-sheet outlined rounded v-for="item in purchaseSSCEs" :key="item.id" class="mb-2">
        <div class="d-flex justify-space-between py-2">
          <div class="my-auto ml-4">
            {{item.examType.title}}
          </div>
          <v-btn class="ml-auto mr-4" :disabled="hasCompletedCard(item) || organizationId(item) == null" depressed text color="success" @click="initializeTransaction(item.id, organizationId(item))">Purchase</v-btn>
        </div>
      </v-sheet>
    </v-form>
    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-btn
          color="primary"
          depressed
          :disabled="!hasScratchCards"
          @click="success"
          v-if="hasScratchCards"
      >{{  noHeader ? 'Save' : 'Proceed' }}</v-btn
      >
      <v-btn
          color="info"
          depressed
          @click="success"
          v-if="hasScratchCards"
      >Skip</v-btn
      >
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box
        :show="messageShow"
        :message="message"
        :type="messageType"
        v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import {PaymentGateway} from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {
  getPurchaseScratchCardSSCEs,
  getScratchCardOrganization,
  hasCompletedScratchCardSSCE,
  isNecoSSCE
} from "@/application/lib/scratchCardEntry";

export default {
  name: "ScratchCard",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data: () => ({
    dataValid: true,
    paymentGateway: null,
    paymentConfig: {},
    payment: null,
    messageType: "",
    message: "",
    messageShow: false,
    loading: false,
  }),

  methods: {
    success() {
      this.$emit("success");
    },

    organizationId(ssce){
      return getScratchCardOrganization(ssce)?.id ?? null
    },

    hasCompletedCard(ssce){
      return hasCompletedScratchCardSSCE(ssce)
    },

    initializeTransaction(ssce, org){
      this.loading = true
      let vm = this;
      Api.scratchCard.getConfig(org)
          .then(res => {
            // set config
            vm.paymentConfig = res.data.paymentPlatform
            this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, vm, undefined)
            this.paymentGateway.initializeGateway(vm.paymentConfig)
            // initialize
            Api.scratchCard.initializeTransaction({ ssceDetail: ssce})
                .then(res => {
                  vm.payment = res.data.feePayment;
                  vm.makePayment()
                }).catch(err => ErrorResolver.checkErrors(this, err))
                .finally(() => this.loading = false)
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    makePayment(){
      //console.log(this.payment)
      this.loading = true
      window.location.href = this.payment.paymentLink
    }
  },

  computed: {
    ...mapGetters(["getSSCEDetails", "getUser"]),

    automaticPurchasesEnabled: function(){
      return (this.getUser?.admission?.applicationType?.autoScratchCards?.length ?? 0) > 0
    },

    purchaseSSCEs: function(){
      return getPurchaseScratchCardSSCEs(this.getSSCEDetails, this.automaticPurchasesEnabled)
    },

    hasMixedOrganizations: function(){
      return this.getSSCEDetails.some(isNecoSSCE)
        && this.getSSCEDetails.some(ssce => !isNecoSSCE(ssce))
    },

    hasScratchCards: function(){
      return this.purchaseSSCEs.length > 0
        && this.purchaseSSCEs.every(hasCompletedScratchCardSSCE)
    }

  },

  created() {
    this.noHeader && this.$emit('update-title', "Scratch cards")
  }
}
</script>

<style scoped>

</style>
